export default "__VITE_ASSET__D3z$QvjD__"